<template>
    <div class="row">
        <div class="col">
            <search scope="mine"></search>
            <result></result>
            <back-to-top></back-to-top>
        </div>
    </div>
</template>

<script>
    import Result from '../data/agent-profiles/Result'
    import Search from '../data/agent-profiles/Search'

    export default {
    
        components: {
            Search, Result
        }
    }
</script>
